import { render } from "./IconCartInCatalog.vue?vue&type=template&id=5776d858"
import script from "./IconCartInCatalog.vue?vue&type=script&lang=js"
export * from "./IconCartInCatalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__